import * as React from 'react';
import { HoldState } from 'types/Watchlist';
import { formatHoldStatus } from 'utils/container-transforms/transforms';

interface Props {
  note: string | null;
  state: HoldState | null;
}

export const HoldCell: React.FC<Props> = (props) => {
  const { note, state } = props;

  const formatted = formatHoldStatus(state, note);

  return (
    <div className="p-2">
      <h4 className={formatted?.meta?.indicate ? 'text-red-900' : ''}>{formatted?.value || '-'}</h4>
    </div>
  );
};
HoldCell.displayName = 'ContainerTable.HoldCell';
